<template>
    <div id="m-inbox" style="height: 100%">
        <v-overlay v-if="loading">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>
        <v-alert type="error" width="20%" v-else-if="message" style="margin-top: 50px;margin-left: 50%;left: -10%;">
            {{ message }}
        </v-alert>
        <v-card v-else elevation="0">
            <a-edit-test-popup ref="a-edit-test-popup"></a-edit-test-popup>
            <v-card-actions>
                <v-card outlined width="100%" class="ma-0 pa-0">
                    <v-card-actions class="ma-0 pa-2">
                        <v-spacer></v-spacer>
                        <v-btn color="blue"
                               elevation="0"
                               class="white--text pl-5 pr-3"
                               @click="onPressNewTesting">
                            New Test
                            <v-icon class="ml-2">mdi-plus</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
            <v-card-actions class="pt-0">
                <v-card width="100%" class="ma-0 pa-0" elevation="0">
                    <a-list-table v-on:show-a-edit-test-popup = "showEditTestPopup"></a-list-table>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import AListTable from "@/modules/maudiences/views/a-list-table";
import AudienceTestStore from "@/modules/maudiences/database/AudienceTestStore";
import AEditTestPopup from "@/modules/maudiences/views/popups/a-edit-test-popup";
import {AudienceTestModel} from "@/modules/maudiences/models/AudienceTestModel";
import {AudienceModel} from "@/modules/maudiences/models/AudienceModel";

export default {
    components: {AEditTestPopup, AListTable},
    data: () => ({
        loading: true,
        message: "",
    }),
    methods: {
        showEditTestPopup(test, editMode){
            this.$refs['a-edit-test-popup'].show(test, editMode);
        },
        onPressNewTesting(){
            let newTest = new AudienceTestModel();
            newTest.audiences = [new AudienceModel("def", 100)]
            this.$refs['a-edit-test-popup'].show(newTest, false);
        },
    },
    beforeMount() {
        this.loading = false
    },
    destroyed() {
        //this.$store.unregisterModule("audience-test-store");
        console.log("destroy root view audiences");
    }
}
</script>

<style scoped>
</style>